import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, CardContent, Dialog, Grid, IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { CountdownCmp } from "../countdown/Countdown";
import { NoticeCountdownCmp } from "../countdown/NoticeCountdown";
import { title } from "process";
import { Formik } from "formik";
import { useMutation } from "react-query";
import { AddSupplierAddress, AddSupplierUsers, GetSupplierAddreses, GetSupplierUsers } from "../../services/report.service";
import { AddSupplierAddressResponse, AddSupplierUsersResponse, getSupplierAddresesResponse, getSupplierUsersResponse } from "../../models/report.model";
import { object, string } from "yup";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";
import AutoCompleteSearch from "../dropdown/AutoCompleteSearch";
import SideSwich from "../switch/SideSwich";
import { GetCitiesResponse } from "../../models/basicInformation.model";
import { GetCities } from "../../services/basicInformation.service";
import { v4 as uuidv4 } from 'uuid';

const style = {
    position: "absolute" as "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
};

export default function ModalAddSupplierBranches({
    openModel,
    setSendConfirmation,
    setOpenVerifyModal,
    setSendNotification,
}: any) {

    const id = window.localStorage.getItem("SUPPLIER_ID");
    const [open, setOpen] = React.useState<boolean>(openModel);
    const [cities, setCities] = React.useState<GetCitiesResponse[]>([]);
    const [showAddBranchForm, setshowAddBranchForm] = React.useState(true);


    const handleClose = () => {
        setOpen(false);
        setOpenVerifyModal(false);
    };
    React.useEffect(() => {
        getCitiesMutate({});
        setOpen(openModel);
    }, [openModel]);

    const { mutate: getCitiesMutate } = useMutation(GetCities, {
        onSuccess: (data: GetCitiesResponse[]) => {
            if (data) {
                setCities(data);
            }
        },
        onError: () => { },
    });


    const branchesValidation = object().shape({
        address: string()
            .ensure()
            .required("لطفا آدرس را وارد نمایید.")
            .matches(/^(?!\s+$).*/, "لطفا آدرس را صحیح وارد نمایید")
            .max(500, "آدرس نباید بیشتر از 500 کاراکتر باشد."),
        email: string()
            .ensure()
            .max(250, "ایمیل نباید بیشتر از 250 کاراکتر باشد.")
            .email("لطفا ایمیل را صحیح وارد نمایید."),
        telNumbers: string()
            .ensure()
            .required("لطفا شماره تماس را وارد نمایید.")
            .matches(
                /(((0?9)|(\+?989))\d{2}\W?\d{3}\W?\d{4})|(\d{8})/,
                "لطفا شماره تماس را صحیح وارد نمایید"
            ),
    });

    const initialValues: any = {
        address: "",
        email: "",
        telNumbers: "",
    };
    const handleAddbranch = (values: any) => {
        AddSupplierAddressMutate({
            supplierAddressId: 0,
            supplierId: Number(id!),
            address: values.address.trim(),
            email: values.email.trim(),
            telNumbers: values.telNumbers,
        });
        setshowAddBranchForm(false);
    };

    const { mutate: AddSupplierAddressMutate } = useMutation(AddSupplierAddress, {
        onSuccess: (data: AddSupplierAddressResponse) => {
            if (data) {
                setSendConfirmation(uuidv4());
                setOpen(false);
                setOpenVerifyModal(false);
            }
        },
        onError: () => { },
    });

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
            >
                <>
                    <Grid>
                        <Box
                            sx={style}
                            style={{ borderRadius: "6px", padding: "50px 40px 40px 40px" }}
                            className="ModalCmp  "
                        >

                            <Formik
                                initialValues={initialValues}
                                onSubmit={handleAddbranch}
                                validateOnMount={true}
                                validationSchema={branchesValidation}
                            >
                                {({
                                    handleSubmit,
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                }) => (
                                    <form
                                        onSubmit={handleSubmit}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                            }
                                        }}
                                    >
                                        <Grid
                                            container
                                            // columns={14}
                                            // gap={1}
                                            xs={12}
                                        // justifyContent={{
                                        //     xs: "center",
                                        //     sm: "center",
                                        //     md: "center",
                                        //     lg: "space-between",
                                        // }}
                                        // alignItems={"center"}
                                        // padding={"0 1rem"}
                                        // minHeight={"100px"}
                                        >
                                            <Grid container xs={12} spacing={2} style={{ paddingBottom: '20px' }}>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <MaterialTextFieldComponent
                                                        placeHolder={"آدرس"}
                                                        label={"آدرس"}
                                                        required={true}
                                                        name={"address"}
                                                        id={"address"}
                                                        // autoFocus={true}
                                                        value={values.address}
                                                        onChange={handleChange}
                                                        helperText={
                                                            touched.address ? errors.address : ""
                                                        }
                                                        error={
                                                            touched.address && Boolean(errors.address)
                                                        }
                                                        onBlur={handleBlur}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container xs={12} spacing={2} style={{ paddingBottom: '20px' }}>
                                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                    <MaterialTextFieldComponent
                                                        placeHolder={"ایمیل"}
                                                        label={"ایمیل"}
                                                        name={"email"}
                                                        id={"email"}
                                                        value={values.email}
                                                        onChange={handleChange}
                                                        helperText={touched.email ? errors.email : ""}
                                                        error={touched.email && Boolean(errors.email)}
                                                        onBlur={handleBlur}
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                    <MaterialTextFieldComponent
                                                        placeHolder={"شماره تماس"}
                                                        label={"شماره تماس"}
                                                        required={true}
                                                        name={"telNumbers"}
                                                        id={"telNumbers"}
                                                        inputProps={{ maxLength: 11 }}
                                                        value={values.telNumbers}
                                                        onChange={handleChange}
                                                        helperText={
                                                            touched.telNumbers ? errors.telNumbers : ""
                                                        }
                                                        error={
                                                            touched.telNumbers &&
                                                            Boolean(errors.telNumbers)
                                                        }
                                                        onBlur={handleBlur}
                                                        onKeyDown={(event) => {
                                                            if (event.code === "Space")
                                                                event.preventDefault();
                                                        }}
                                                    />
                                                </Grid>

                                            </Grid>

                                            <Grid container xs={12}>
                                                <Grid item xs={6}></Grid>
                                                <Grid item xs={6}>
                                                    <Grid
                                                        container
                                                        justifyContent={"center"}
                                                        alignItems={"center"}
                                                        gap={1}
                                                        marginBottom={"8px"}
                                                    >
                                                        <Grid item xs={5} width={"100%"}>
                                                            <Button
                                                                fullWidth
                                                                type="submit"
                                                                variant="contained"
                                                                disabled={
                                                                    !values.address || !values.telNumbers
                                                                }
                                                                className={
                                                                    !values.address || !values.telNumbers
                                                                        ? "btnForm disabledBtn"
                                                                        : "btnForm SuccessDefault"
                                                                }
                                                            >
                                                                افزودن
                                                            </Button>
                                                        </Grid>
                                                        <Grid item xs={5} width={"100%"}>
                                                            <Button
                                                                onClick={handleClose}
                                                                fullWidth
                                                                variant="contained"
                                                                style={{
                                                                    fontSize: "1rem",
                                                                    color: "#fff",
                                                                    height: "40px",
                                                                    background: "#607D8B",
                                                                }}
                                                            >
                                                                انصراف
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                            </Grid>
                                        </Grid>
                                    </form>
                                )}
                            </Formik>
                        </Box>
                    </Grid>
                </>
            </Modal>
        </div >
    );
}
